import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';
import { StylePreset } from '@/styles/styleClassPreset';

/** 角色管理代码加载时保留左右分栏，沿用角色列表首次加载与未选中角色的布局 */
export function RoleManagementSkeleton() {
  return (
    <div
      className={cn(StylePreset.MAIN_CONTENT_HEIGHT, 'flex flex-col overflow-hidden relative')}
      aria-hidden="true"
    >
      <div className="flex-1 flex flex-row gap-5 h-[calc(100%-(var(--spacing)*11))] relative">
        {/** 角色列表标题、新增入口和搜索框 */}
        <Card className="w-[20%] max-w-100 min-w-50 flex flex-col gap-2">
          <CardHeader>
            <div className="flex flex-row justify-between items-center">
              <Skeleton className="h-6 w-16" />
              <Skeleton className="h-8 w-24" />
            </div>
            <Skeleton className="h-9 w-full" />
          </CardHeader>
          {/** 与现有角色列表首次请求时的五行占位保持一致 */}
          <div className="flex-1 relative min-h-0">
            <CardContent className="h-full overflow-hidden">
              <div className="flex flex-col gap-2">
                {Array.from({ length: 5 }, (_, index) => (
                  <div key={index} className="flex items-center gap-2 rounded-md p-2">
                    <Skeleton className="h-8 w-8 shrink-0 rounded-full" />
                    <Skeleton className="h-8 flex-1" />
                  </div>
                ))}
              </div>
            </CardContent>
          </div>
        </Card>

        {/** 初始尚未选中角色，不提前展示权限树或编辑入口 */}
        <Card className="flex-1 flex flex-col gap-2">
          <CardContent className="flex items-center justify-center w-full h-full">
            <Skeleton className="h-6 w-40" />
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
